import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Discounts(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='discounts-glance-body'
                cssHeadingClass='discounts-glance-heading'
                cssIconClass='icons8-discount'
                Heading={t('Discounts')}
                DataPoint1={props.DP1}
                DataPoint2={(Math.sign(props.DP2) > 0) ? "<i class='icons8-sort-up' aria-hidden='true' style='font-size: 26px; color: green; vertical-align: middle;'  />" + props.DP2 + '%'
                    : "<i class='icons8-sort-down' aria-hidden='true' style='font-size: 26px; color: red; vertical-align: middle;'  />" + props.DP2 + '%'}
                DataPoint3={props.DP3 + ' ' + t('Checks')}
                showForwardButton={true}
            ></BaseDataGlance>
        </>
    );
}